import { useHistory } from 'react-router-dom';
import './TopPanel.css';
import logo from '../assets/logo.svg';
import useAuth from '../../auth/useAuth';

const TopPanel = () => {
  const history = useHistory();
  const auth = useAuth();

  return (
    <header className="top-panel">
      <div className="top-panel__main">
        <div className="top-panel__main-content">
          <div className="top-panel__logo" onClick={() => history.push('/')} style={{ cursor: 'pointer' }}>
            <img src={logo} alt="WinningPartner" />
          </div>
          <div className="top-panel__actions">
            {auth.isAuthenticated ? (
              <>
                <span className="top-panel__user-name">{auth.user.fullName}</span>
                <button
                  className="top-panel__btn top-panel__btn--login"
                  onClick={() => history.push('/admin/overview')}
                >
                  Dashboard
                </button>
                <button
                  className="top-panel__btn top-panel__btn--signup"
                  onClick={auth.logout}
                >
                  Log Out
                </button>
              </>
            ) : (
              <>
                <button
                  className="top-panel__btn top-panel__btn--login"
                  onClick={() => history.push('/login')}
                >
                  Log In
                </button>
                <button
                  className="top-panel__btn top-panel__btn--signup"
                  onClick={() => history.push('/signup')}
                >
                  Sign Up
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopPanel;
